import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { HelmetProvider } from "react-helmet-async";
import OrganizationSchema from "./component/OrganizationSchema";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Service from "./pages/Service";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import BlogDetail2 from "./pages/BlogDetail2";
import BlogDetail3 from "./pages/BlogDetail3";
import BlogDetail4 from "./pages/BlogDetail4";
import CaseStudies from "./pages/CaseStudies";
import Career from "./pages/Career";
import HomeBlog1 from "./pages/HomeBlog1";
import HomeBlog2 from "./pages/Homeblog2";
import HomeBlog3 from "./pages/HomeBlog3";

function App() {
  return (
    <HelmetProvider>
      <OrganizationSchema />
      <BrowserRouter>
        <Toaster position="top-right" reverseOrder={false} />
        <Routes>
          <Route path="/" index element={<Home />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path={"/about"} element={<About />} />
          <Route path={"/contact"} element={<Contact />} />
          <Route path={"/service"} element={<Service />} />
          <Route path={"/career"} element={<Career />} />
          <Route path={"/blog"} element={<Blog />} />
          <Route path={"/blog-detail"} element={<BlogDetail />} />
          <Route path={"/blog-detail2"} element={<BlogDetail2 />} />
          <Route path={"/blog-detail3"} element={<BlogDetail3 />} />
          <Route path={"/blog-detail4"} element={<BlogDetail4 />} />
          <Route path={"/home-blog1"} element={<HomeBlog1 />} />
          <Route path={"/home-blog2"} element={<HomeBlog2 />} />
          <Route path={"/home-blog3"} element={<HomeBlog3 />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
